import React from 'react';
import type { SkeletonBarProps } from './types';

const SHAPE_CLASS: Record<NonNullable<SkeletonBarProps['shape']>, string> = {
    bar: 'rounded',
    circle: 'rounded-full',
    block: 'rounded-lg',
};

export const SkeletonBar: React.FC<SkeletonBarProps> = ({ className, shape = 'bar', testId }) => (
    <div data-testid={testId} className={`bg-primary-200 animate-pulse ${SHAPE_CLASS[shape]} ${className}`} />
);
